declare namespace $ {

	type $shm_sort__sort_by_shm_projects_tasks_panel_1 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks_panel['sort_by'] >
		,
		ReturnType< $shm_sort['sort_by'] >
	>
	type $shm_sort__sort_order_shm_projects_tasks_panel_2 = $mol_type_enforce<
		ReturnType< $shm_projects_tasks_panel['sort_order'] >
		,
		ReturnType< $shm_sort['sort_order'] >
	>
	type $shm_sort__options_shm_projects_tasks_panel_3 = $mol_type_enforce<
		({ 
			'created': string,
			'updated': string,
		}) 
		,
		ReturnType< $shm_sort['options'] >
	>
	type $mol_pick__hint_shm_projects_tasks_panel_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_shm_projects_tasks_panel_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_projects_tasks_panel_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	export class $shm_projects_tasks_panel extends $shm_service_task_list {
		Menu_trigger_icon( ): $mol_icon_dots_vertical
		Sort( ): $shm_sort
		sort_by( next?: string ): string
		sort_order( next?: string ): string
		Sort_menu( ): $mol_pick
	}
	
}

//# sourceMappingURL=panel.view.tree.d.ts.map